import { getProfiles } from '../state-manager.js';

export const pendingFoods = [];

export function addFood({ name, weight, barcode, profileIds }) {
  const trimmedName = name?.trim();
  const numericWeight = parseFloat(weight);

  if (!trimmedName || isNaN(numericWeight)) {
    alert('Please enter a valid food name and weight.');
    return;
  }

  pendingFoods.push({
    name: trimmedName,
    weight: numericWeight,
    barcode: barcode?.trim() || null,
    profileIds: profileIds || [],
  });
}

export function resetFoodForm() {
  document.getElementById('settings-food-name').value = '';
  document.getElementById('settings-food-weight').value = '';
  document.getElementById('settings-food-barcode').value = '';
  document.getElementById('settings-food-profile-ids').selectedIndex = -1;
}

export function populateProfilesSelect(selectId = 'settings-food-profile-ids') {
  const select = document.getElementById(selectId);
  if (!select) return;

  select.innerHTML = '';
  const profiles = getProfiles();

  profiles.forEach(profile => {
    const option = document.createElement('option');
    option.value = profile.id;
    option.textContent = profile.name;
    select.appendChild(option);
  });
}

export function renderFoodPreview(containerId = 'settings-food-tags') {
  const container = document.getElementById(containerId);
  if (!container) return;

  container.innerHTML = '';
  const profiles = getProfiles();

  pendingFoods.forEach((food, index) => {
    const profileNames = food.profileIds.map(pid => {
      const match = profiles.find(p => p.id === pid);
      return match?.name || pid;
    });

    const tag = document.createElement('div');
    tag.className = 'settings-food-tag';
    tag.innerHTML = `
      ${food.name} (${food.weight}g)
      ${profileNames.length ? `<span class="profile-ids">→ [${profileNames.join(', ')}]</span>` : ''}
      <button class="remove-tag" title="Remove" data-index="${index}">&times;</button>
    `;
    container.appendChild(tag);
  });

  container.querySelectorAll('.remove-tag').forEach(btn => {
    btn.addEventListener('click', () => {
      const i = Number(btn.dataset.index);
      pendingFoods.splice(i, 1);
      renderFoodPreview(containerId);
    });
  });
}
